module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/meeting-8eb71fc0cd11cdefee92c6f2d7f2ed24.jpg";